import { PropsWithChildren } from "react";
import { useAuth } from "@/contexts/AuthContext";
import AwaitingApproval from "@/components/pages/AwaitingApproval";
import Spinner from "@/components/atoms/Spinner/Spinner";

/**
 * Renders the awaiting-approval page instead of the app while the current company isn't approved by Reviver. While
 * the company is still loading it shows a spinner, so app pages don't flash (or fire requests) before the decision.
 */
export default function AwaitingApprovalGate({ children }: PropsWithChildren) {
  const { isCurrentCompanyAwaitingApproval, isCurrentCompanyLoading } = useAuth();

  if (isCurrentCompanyLoading) return <Spinner loading={true} />;
  if (isCurrentCompanyAwaitingApproval) return <AwaitingApproval />;
  return <>{children}</>;
}
